import { Injectable } from "@angular/core";
import { ProfileService } from 'app/profile/services/profile.service';
import { SupplierProfileState } from '../app.reducer';
import { Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import {
    GET_MANUFACTURING_LOCATIONS,
    GetManufacturingLocationsSuccess,
    GetManufacturingLocations,
    GET_UNIT_OF_MEASURE,
    GetUnitOfMeasureSuccess
} from '../actions/site.action';
import { withLatestFrom, filter, exhaustMap, switchMap, catchError, map } from 'rxjs/operators';
import { getManufacturingSites, getUnitOfMeasure } from '../selectors/site.selector';
import { IncrementLoaderCount, DecrementLoaderCount, PushError } from 'app/shared/store/actions';
import { Location } from 'app/profile/models/profile.model';
import { SiteService } from 'app/profile/services/site.service';
import { UnitOfMeasure, Commodity } from 'app/profile/models/site.model';
import { GET_COMMODITIES, GetCommoditiesSuccess } from '../actions/product.action';
import { getCommodities } from '../selectors/product.selector';

@Injectable()
export class SiteEffects {
    constructor(private service: ProfileService,
        private siteService: SiteService,
        private store: Store<SupplierProfileState>,
        private actions$: Actions) {}

    @Effect()
    loadManufacturingSites$ = this.actions$
        .pipe(
            ofType(GET_MANUFACTURING_LOCATIONS),
            map((action: GetManufacturingLocations) => action),
            withLatestFrom(this.store.select(getManufacturingSites)),
            filter(([, state]) => state === null),
            exhaustMap(([action]) => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.service.getLocations(action.payload)
                    .pipe(
                        switchMap((res: Location[]) => {
                            return [
                                new GetManufacturingLocationsSuccess(res),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError(err => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    );
            })
        );

    @Effect()
    loadUnitOfMeasure$ = this.actions$
        .pipe(
            ofType(GET_UNIT_OF_MEASURE),
            withLatestFrom(this.store.select(getUnitOfMeasure)),
            filter(([, state]) => state === null),
            exhaustMap(([action]) => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.siteService.getUnitOfMeasure()
                    .pipe(
                        switchMap((res: UnitOfMeasure[]) => {
                            return [
                                new GetUnitOfMeasureSuccess(res),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError(err => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    );
            })
        );

    @Effect()
    loadCommodities$ = this.actions$
        .pipe(
            ofType(GET_COMMODITIES),
            withLatestFrom(this.store.select(getCommodities)),
            filter(([,state]) => state == null),
            exhaustMap(([action]) => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.siteService.getCommodities()
                    .pipe(
                        switchMap((res: Commodity[]) => {
                            return [
                                new GetCommoditiesSuccess(res),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError(err => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    );
            })
        );
}
